import React, { useState, useEffect } from 'react';
import { DialogActions, Button, TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import HeaderMenu from '../Header/HeaderMenu';
import axiosApi from '../Utils/axiosApi';
import checkPermission from '../Utils/checkPermission';
const CreateCompany = ({ open, onClose, company, isDialog = false,onSuccess  }) => {
  const [companyName, setCompanyName] = useState('');
  const [companyType, setCompanyType] = useState('');
  const [description, setDescription] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Populate form if editing
  useEffect(() => {
    if (company) {
      setCompanyName(company.companyName || '');
      setCompanyType(company.companyType || '');
      setDescription(company.description || '');
    } else {
      setCompanyName('');
      setCompanyType('');
      setDescription('');
    }
  }, [company]);

    const handleSubmit = async (e) => {
  e.preventDefault();
  
  const companyDTO = {
    companyName: companyName,
    companyType: companyType,
    description: description,
    ...(company?.id && { id: company.id }), // Include ID for updates
  };

  const apiUrl = company ? '/company/updateCompany' : '/company/createCompany';

  try {
    await axiosApi.post(apiUrl, {companyDTO}); // <-- 🔥 send directly companyDTO, not { companyDTO }

    setSuccessMessage(company ? "Company updated successfully!" : "Company created successfully!");
    setErrorMessage('');
     if (onSuccess) {
        onSuccess(); // 👈 tell parent to refresh
      }

  } catch (error) {
    console.error("Error processing Company:", error?.response?.data || error.message);
    setErrorMessage("Error processing Company. Please try again.");
    setSuccessMessage('');
  }
};



  return (
    <>
      {!isDialog && <HeaderMenu />}
	  
	   
		{/* SUCCESS OR ERROR BANNER */}
      {(successMessage || errorMessage) && (
        <div
          style={{
            backgroundColor: successMessage ? '#d4edda' : '#f8d7da',
            color: successMessage ? '#155724' : '#721c24',
            border: `1px solid ${successMessage ? '#c3e6cb' : '#f5c6cb'}`,
            padding: '10px 20px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          {successMessage || errorMessage}
        </div>
      )}
	  
<h2> Create Company </h2>
      <form onSubmit={handleSubmit} style={{ padding: '1rem' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
          <TextField
            label="Company Name"
            variant="outlined"
            fullWidth
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            required
          />

          <FormControl fullWidth variant="outlined" required>
            <InputLabel id="company-type-label">Company Type</InputLabel>
            <Select
              labelId="company-type-label"
              value={companyType}
              onChange={(e) => setCompanyType(e.target.value)}
              label="Company Type"
            >
              <MenuItem value="HOSTEL_OPERATOR">Hostel Operator</MenuItem>
              <MenuItem value="ADMIN">Admin</MenuItem>
              <MenuItem value="FOOD_SUPPLIER">Food Supplier</MenuItem>
			  <MenuItem value="HOTEL_MANAGER">Hotel Manager</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Description"
            variant="outlined"
            fullWidth
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <DialogActions sx={{ marginTop: 2 }}>
          <Button disabled={!checkPermission("Admin", "Companys", "CREATE")} type="submit" color="primary" variant="contained">
            {company ? 'Update' : 'Create'}
          </Button>
          <Button onClick={onClose} color="secondary" variant="outlined">
            Close
          </Button>
        </DialogActions>

       
      </form>
    </>
  );
};

export default CreateCompany;
